import Axios from '../axios'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { logError } from 'shared'
// import { ISupportDataSsp } from '../../interfaces/i-api-support'
import appConfig from 'app.config'

async function CreateReferalLinkService(partyId: string) {
	const { data } = await Axios.post(
		`${appConfig.customerDataBaseUrl}/api/ReferralLink/create`,
		{ partyId: partyId },
		await getHeadersWithJwtToken()
	)
		.then((res) => {
			return res
		})
		.catch((err) => {
			console.log(err)
			logError(err)
			throw new Error(err)
		})
	return data
}

export default CreateReferalLinkService
